import React from "react";
import { Helmet } from "react-helmet-async";

/**
 * Reusable SEO / Open Graph component for React SPA
 */
export default function Seo({
  title,
  description,
  path = "/",
  image = "https://aisectintercollege.in/assets/og/aisect_inter_college_bn_1.png",
  type = "website",
  siteName = "AISECT Inter College",
  changeLocale = "en_IN",
}) {
  const url = `https://aisectintercollege.in${path}`;

  return (
    <Helmet>
      <title>{title}</title>

      <meta name="description" content={description} />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content={changeLocale} />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />

      {/* Canonical */}
      <link rel="canonical" href={url} />
    </Helmet>
  );
}
